<template>
    <b-navbar toggleable="xl" fixed="top" v-b-scrollspy:nav-scroller class="header-area text-trustami-blue" :class="{ 'is-sticky': scrolled }">
        <div class="container-fluid container-fluid--cp-150">
            <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
            <b-navbar-brand class="navbar-brand logo-light" to="/">
                <img :src='"../assets/img/logo/logo.svg"' alt="logo">
            </b-navbar-brand>
            <b-navbar-brand class="navbar-brand logo-dark" to="/">
                <img :src='"../assets/img/logo/logo.svg"' alt="logo">
            </b-navbar-brand>
            <b-collapse class="default-nav justify-content-center" is-nav id="nav_collapse">
                <b-navbar-nav class="navbar-nav main-menu text-trustami-blue">
                    <b-nav-item href="#home" class="scroll" @click="usedSCrollMenu('Home', '#home')"><span>{{ $t("navbar.home") }}</span></b-nav-item>
                    <b-nav-item href="#about" class="scroll" @click="usedSCrollMenu('About', '#about')"><span>{{ $t("navbar.about") }}</span></b-nav-item>
                    <b-nav-item href="#services" class="scroll" @click="usedSCrollMenu('Services', '#services')"><span>{{ $t("navbar.services") }}</span></b-nav-item>
                    <b-nav-item href="#support" class="scroll" @click="usedSCrollMenu('Support', '#support')"><span>{{ $t("navbar.support") }}</span></b-nav-item>
                    <li class="nav-item"><a :href="`${lang}/pricing`" class="nav-link router-link-active"><span>{{ $t("navbar.pricing") }}</span></a></li>
                    <li class="nav-item"><a :href="`${lang}/research`" class="nav-link router-link-active"><span>{{ $t("navbar.research") }}</span></a></li>
                    <li class="nav-item"><a :href="`${lang}/knowledge`" class="nav-link router-link-active"><span>{{ $t("navbar.knowledge") }}</span></a></li>

                    <li class="nav-item mobile-only"><a href="https://app.trustami.ai/login" class="nav-link router-link-active"><span>{{ $t("navbar.login") }}</span></a></li>
                    <li class="nav-item mobile-only"><a href="#" @click="signUp" class="nav-link router-link-active"><span>{{ $t("navbar.signin") }}</span></a></li>
                </b-navbar-nav>
            </b-collapse>
            <b-btn-group class="header-button button--white d-none d-xl-block">
                <LangSwitch />

                <b-link class="btn btn--white sign-up-button-nav space-right" href="https://app.trustami.ai/login">{{ $t("navbar.login") }}</b-link>
                <b-link class="btn btn--white sign-up-button-nav" @click="signUp">{{ $t("navbar.signin") }}</b-link>
            </b-btn-group>
        </div>
    </b-navbar>
</template>

<script>
import LangSwitch from './LangSwitch.vue';

export default {
    name: 'Navbar',
    components: {
        LangSwitch
    },
    data() {
        return {
            load: false,
            limitPosition: 200,
            scrolled: false,
            lastPosition: 500,
        }
    },
    computed: {
        lang() {
            const lang = this.$i18n.locale;

            return lang !== 'en' ? `/${lang}` : '';
        }
    },
    mounted() {
        scrollTo();

        function scrollTo() {
            const links = document.querySelectorAll('.scroll > a');
            links.forEach(each => (each.onclick = scrollAnchors));
        }

        function scrollAnchors(e, respond = null) {
            const distanceToTop = el => Math.floor(el.getBoundingClientRect().top);

            e.preventDefault();

            const targetID = (respond) ? respond.getAttribute('href') : this.getAttribute('href');

            if (targetID === '/') {
                window.location.href = targetID;
                return;
            }

            const targetAnchor = document.querySelector(targetID);

            if (!targetAnchor) return;

            const originalTop = distanceToTop(targetAnchor);

            window.scrollBy({top: originalTop, left: 0, behavior: 'smooth'});

            const checkIfDone = setInterval(() => {
                const atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 190;

                if (distanceToTop(targetAnchor) === 0 || atBottom) {
                    targetAnchor.tabIndex = '-1';
                    targetAnchor.focus();

                    clearInterval(checkIfDone);
                }
            }, 800);
        }
    },
    methods: {
        // sticky menu script
        handleScroll() {
            if (this.lastPosition < window.scrollY && this.limitPosition < window.scrollY) {
                this.scrolled = true;
                // move up!
            }

            if (this.lastPosition > window.scrollY) {
                this.scrolled = true;
                // move down
            }

            this.lastPosition = window.scrollY;
            this.scrolled = window.scrollY > 50;
        },
        usedSCrollMenu(title, hash) {
            this.$root.$emit('pageview', hash, title);
        },
        doSignUp() {
            window.location = 'https://app.trustami.ai/register';
        },
        signUp($event) {
            $event.preventDefault();

            if (!window.hasGACookies || window._blocked) {
                this.doSignUp();

                return;
            }

            this.$gtag.conversion({
                'send_to': 'AW-950463112/8krmCOnH94oYEIjVm8UD',
                'event_callback': () => {
                    this.doSignUp();
                }
            });
        }
    },
    created() {
        window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
        window.removeEventListener("scroll", this.handleScroll);
    },
}
</script>
